/*eslint-disable */
import axios from 'axios';
import moment from 'moment';
import root from '@/_helpers/roots';
let sentEmailSmsListApiUrl = root.sentEmailSmsListApiUrl.link;
export default {
  name: 'sent-email-sms-page',
  components: {},
  props: [],
  data () {
    return {
      emailSmsData:null,
      emailSmsDataRslt:[],
      is_type:'',
      is_year:'',
      is_month:'',
      is_selected_type:'',
      is_month_name:'',
      userLoading:false,
      filterEnabledState:false
    }
  },
  computed: {

  },
  mounted () {
    axios.get(sentEmailSmsListApiUrl).then((res) => {
      this.emailSmsData = res.data.data
      this.emailSmsDataRslt = this.emailSmsData.results 
    })
  },
  methods: {
    clearFiltersMethod(){
      this.filterEnabledState = false
      this.is_type = '' 
      this.is_selected_type = ''
      this.is_year = ''
      this.is_month_name = ''
      this.is_month = ''
      this.userLoading = true
      axios.get(sentEmailSmsListApiUrl).then((res) => {
        this.emailSmsData = res.data.data
        this.emailSmsDataRslt = this.emailSmsData.results 
        this.userLoading = false
      }).catch((err) => {
        this.userLoading = false
      })
    },
    filterByIsTypeMethod(val, key){
      this.filterEnabledState = true
      this.is_type = val
      this.is_selected_type = key
      this.userLoading = true
      axios.get(sentEmailSmsListApiUrl + '?is_year=' + this.is_year + '&is_month=' + this.is_month + '&is_type=' + this.is_selected_type).then((response) => {
        this.emailSmsData = response.data.data
        this.emailSmsDataRslt = this.emailSmsData.results
        this.userLoading = false
      })
    },
    filterByIsYearMethod(val){
      this.filterEnabledState = true
      this.is_year = val
      this.userLoading = true
      axios.get(sentEmailSmsListApiUrl + '?is_year=' + this.is_year + '&is_month=' + this.is_month + '&is_type=' + this.is_selected_type).then((response) => {
        this.emailSmsData = response.data.data
        this.emailSmsDataRslt = this.emailSmsData.results
        this.userLoading = false
      })
    },
    filterByIsMonthMethod(name, val){
      this.filterEnabledState = true
      this.is_month_name = name
      this.is_month = val
      this.userLoading = true
      const is_year = this.is_year || moment(new Date()).format('YYYY')
      axios.get(sentEmailSmsListApiUrl + '?is_year=' + is_year + '&is_month=' + this.is_month + '&is_type=' + this.is_selected_type).then((response) => {
        this.emailSmsData = response.data.data
        this.emailSmsDataRslt = this.emailSmsData.results
        this.userLoading = false
      })
    },
  }
}


